import { SearchModel } from "../models/AbilityModel";

const parseParams = (params: SearchModel) => {
    if (params.page) {
        params.page = +params.page
    }
    if (params.per_page) {
        params.per_page = +params.per_page
    }
    return params
}

export default parseParams;